import { render, staticRenderFns } from "./PMForm.vue?vue&type=template&id=1651485e"
import script from "./PMForm.vue?vue&type=script&lang=js"
export * from "./PMForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports